import React, { useState, useEffect, useRef, useMemo } from 'react';

// Import all client images
import client1 from '../../assets/home/clients/client1.png';
import client2 from '../../assets/home/clients/client2.png';
import client3 from '../../assets/home/clients/client3.png';
import client4 from '../../assets/home/clients/client4.png';
import client5 from '../../assets/home/clients/client5.png';
import client6 from '../../assets/home/clients/client6.png';
import client7 from '../../assets/home/clients/client7.png';
import client8 from '../../assets/home/clients/client8.png';
import client9 from '../../assets/home/clients/client9.png';
import client10 from '../../assets/home/clients/client10.png';
import client11 from '../../assets/home/clients/client11.png';
import client12 from '../../assets/home/clients/client12.png';
import client13 from '../../assets/home/clients/client13.png';
import client14 from '../../assets/home/clients/client14.png';
import client15 from '../../assets/home/clients/client15.png';
import client16 from '../../assets/home/clients/client16.png';
import client17 from '../../assets/home/clients/client17.png';
import client18 from '../../assets/home/clients/client18.png';
import client19 from '../../assets/home/clients/client19.png';
import client20 from '../../assets/home/clients/client20.png';
import client21 from '../../assets/home/clients/client21.png';
import client22 from '../../assets/home/clients/client22.png';
import client23 from '../../assets/home/clients/client23.png';
import client24 from '../../assets/home/clients/client24.png';
import client25 from '../../assets/home/clients/client25.png';
import client26 from '../../assets/home/clients/client26.png';
import client27 from '../../assets/home/clients/client27.png';

const ClientSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [imageErrors, setImageErrors] = useState(new Set());
  const sectionRef = useRef(null);

  // Enhanced clients data with SEO-optimized content
  const allClients = useMemo(() => [
    {
      img: client1,
      alt: "DeHaat - Agricultural technology platform partnering with RoadExpress",
      name: "DeHaat",
      description: "Agricultural technology platform"
    },
    {
      img: client2,
      alt: "Delhivery - Leading logistics company using RoadExpress services",
      name: "Delhivery",
      description: "Leading logistics and supply chain company"
    },
    {
      img: client3,
      alt: "Flipkart - E-commerce giant trusting RoadExpress for logistics",
      name: "Flipkart",
      description: "India's leading e-commerce marketplace"
    },
    {
      img: client4,
      alt: "V-Trans - Transportation partner with RoadExpress logistics network",
      name: "V-Trans",
      description: "Transportation and logistics services"
    },
    {
      img: client5,
      alt: "Let's Transport - Digital logistics platform partnering with RoadExpress",
      name: "Let's Transport",
      description: "Digital logistics platform"
    },
    {
      img: client6,
      alt: "APAM - Logistics client using RoadExpress transportation services",
      name: "APAM",
      description: "Logistics and transportation services"
    },
    {
      img: client7,
      alt: "GoBOLT - Technology-enabled logistics company with RoadExpress",
      name: "GoBOLT",
      description: "Technology-enabled logistics company"
    },
    {
      img: client8,
      alt: "OM Logistics Ltd - Comprehensive logistics partner of RoadExpress",
      name: "OM Logistics Ltd",
      description: "Comprehensive logistics solutions provider"
    },
    {
      img: client9,
      alt: "TCI - Transport Corporation of India partnering with RoadExpress",
      name: "TCI",
      description: "Transport Corporation of India"
    },
    {
      img: client10,
      alt: "Rhenus Logistics - Global logistics company using RoadExpress services",
      name: "Rhenus Logistics",
      description: "Global logistics and supply chain solutions"
    },
    {
      img: client11,
      alt: "GOGOX - On-demand logistics platform with RoadExpress integration",
      name: "GOGOX",
      description: "On-demand logistics platform"
    },
    {
      img: client12,
      alt: "Jusda - Logistics company partnering with RoadExpress network",
      name: "Jusda",
      description: "Logistics and transportation services"
    },
    {
      img: client13,
      alt: "East India - Enterprise client using RoadExpress logistics solutions",
      name: "East India",
      description: "Enterprise logistics solutions"
    },
    {
      img: client14,
      alt: "ICM Logistics - Strategic partner in RoadExpress network",
      name: "ICM Logistics",
      description: "Strategic logistics partner"
    },
    {
      img: client15,
      alt: "RS Logistics - Third-party logistics provider with RoadExpress",
      name: "RS Logistics",
      description: "Third-party logistics provider"
    },
    {
      img: client16,
      alt: "Patanjali Parivahan - Transportation services integrated with RoadExpress",
      name: "Patanjali Parivahan",
      description: "Transportation services provider"
    },
    {
      img: client17,
      alt: "DHL - Global express delivery company partnering with RoadExpress",
      name: "DHL",
      description: "Global express delivery and logistics"
    },
    {
      img: client18,
      alt: "Scorpion Logistics - Specialized logistics partner of RoadExpress",
      name: "Scorpion Logistics",
      description: "Specialized logistics services"
    },
    {
      img: client19,
      alt: "Express Roadways - Road transport company with RoadExpress network",
      name: "Express Roadways",
      description: "Road transport and logistics"
    },
    {
      img: client20,
      alt: "JD Logistics - Regional logistics partner with RoadExpress",
      name: "JD Logistics",
      description: "Regional logistics solutions"
    },
    {
      img: client21,
      alt: "ASC - Logistics company using RoadExpress transportation network",
      name: "ASC",
      description: "Logistics and supply chain services"
    },
    {
      img: client22,
      alt: "CCI - Corporate client trusting RoadExpress for logistics needs",
      name: "CCI",
      description: "Corporate logistics solutions"
    },
    {
      img: client23,
      alt: "Inland World Logistics - International logistics partner of RoadExpress",
      name: "Inland World Logistics",
      description: "International logistics services"
    },
    {
      img: client24,
      alt: "AVG - Logistics client leveraging RoadExpress services",
      name: "AVG",
      description: "Logistics and transportation"
    },
    {
      img: client25,
      alt: "Onmove - Innovation-focused logistics partner with RoadExpress",
      name: "Onmove",
      description: "Innovation-focused logistics"
    },
    {
      img: client26,
      alt: "Best Roadways - Railway logistics company with RoadExpress",
      name: "Best Roadways",
      description: "Railway logistics and transportation"
    },
    {
      img: client27,
      alt: "SafeExpress - Express logistics company partnering with RoadExpress",
      name: "SafeExpress",
      description: "Express logistics and courier services"
    }
  ], []);

  // Handle image loading errors
  const handleImageError = (index, clientName) => {
    setImageErrors(prev => new Set([...prev, index]));
    console.error(`Failed to load client image: ${clientName}`);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.2,
        rootMargin: '50px'
      }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="w-full bg-gray-50"
      aria-labelledby="clients-section-title"
      role="region"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <header className="text-center mb-16">
          <h2
            id="clients-section-title"
            className={`text-3xl md:text-4xl font-bold text-gray-800 transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
              }`}
          >
            Some of our <span className="text-[#F05A28]">prominent clients</span>
          </h2>
          <p
            className={`mt-4 text-lg text-gray-600 max-w-3xl mx-auto transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
              }`}
            style={{ transitionDelay: '0.2s' }}
          >
            Trusted by leading companies across India for reliable logistics and transportation solutions.
          </p>
        </header>

        {/* Client Grid - Keeping your exact design */}
        <div
          className="flex flex-wrap justify-center gap-8 lg:gap-8"
          role="region"
          aria-labelledby="client-logos-title"
        >
          <h3 id="client-logos-title" className="sr-only">
            Client Company Logos
          </h3>

          {allClients.map((client, index) => (
            <article
              key={`client-${index}`}
              className={`group transform transition-all duration-700 hover:scale-110 focus-within:scale-110 ${isVisible
                ? 'translate-y-0 opacity-100'
                : 'translate-y-12 opacity-0'
                }`}
              style={{
                transitionDelay: `${Math.min(index * 0.05, 1)}s`
              }}
              role="img"
              aria-labelledby={`client-name-${index}`}
              aria-describedby={`client-desc-${index}`}
            >
              <div className="w-28 h-16 md:w-32 md:h-18 lg:w-36 lg:h-20 flex items-center justify-center bg-white rounded-lg shadow-sm hover:shadow-lg transition-all duration-300 p-4 border border-gray-100 group-hover:border-[#F05A28]/20 focus-within:border-[#F05A28]/40">
                {!imageErrors.has(index) ? (
                  <img
                    src={client.img}
                    alt={client.alt}
                    className="max-w-full max-h-full object-contain transition-all duration-300 "
                    loading="lazy"
                    onError={() => handleImageError(index, client.name)}
                    onLoad={() => {
                      if (imageErrors.has(index)) {
                        setImageErrors(prev => {
                          const newSet = new Set(prev);
                          newSet.delete(index);
                          return newSet;
                        });
                      }
                    }}
                  />
                ) : (
                  // Fallback for failed images
                  <div className="w-full h-full flex items-center justify-center text-gray-400 text-xs text-center">
                    <div>
                      <div className="text-lg mb-1">🏢</div>
                      <div className="text-[10px] leading-tight">{client.name}</div>
                    </div>
                  </div>
                )}

                {/* Hidden content for SEO and accessibility */}
                <div className="sr-only">
                  <h4 id={`client-name-${index}`}>{client.name}</h4>
                  <p id={`client-desc-${index}`}>{client.description}</p>
                </div>
              </div>

              {/* Tooltip for desktop - only show on hover */}
              {/* <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap z-10 hidden lg:block">
                {client.name}
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900"></div>
              </div> */}
            </article>
          ))}
        </div>

        {/* Trust indicators */}
        <div
          className={`mt-12 text-center transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
            }`}
          style={{ transitionDelay: '1s' }}
        >
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-gray-600 text-sm">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" aria-hidden="true"></div>
              <span>300+ trusted partners</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" aria-hidden="true"></div>
              <span>Industry-leading companies</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" aria-hidden="true"></div>
              <span>Nationwide network</span>
            </div>
          </div>
        </div>
      </div>

      {/* Structured Data for SEO */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "RoadExpress",
          "description": "Leading logistics company trusted by prominent clients across India",
          "client": allClients.map(client => ({
            "@type": "Organization",
            "name": client.name,
            "description": client.description
          })),
          "hasCredential": {
            "@type": "EducationalOccupationalCredential",
            "credentialCategory": "Client Partnership",
            "recognizedBy": allClients.map(client => client.name)
          },
          "award": `Trusted by ${allClients.length}+ leading companies`,
          "serviceArea": {
            "@type": "Country",
            "name": "India"
          }
        })}
      </script>

      {/* CSS for enhanced effects */}
      <style jsx>{`
        @media (prefers-reduced-motion: reduce) {
          * {
            transition-duration: 0.01ms !important;
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
          }
        }
        
        /* Enhanced grayscale effect */
        .filter.grayscale {
          filter: grayscale(70%);
        }
        
        .group:hover .filter.grayscale {
          filter: grayscale(0%) brightness(110%);
        }
        
        /* Staggered animation performance optimization */
        @media (max-width: 768px) {
          article {
            transition-delay: 0s !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ClientSection;